export enum ModalTypesEnum {
    INCOMING_CALL = 'incoming_call__modal',
    CUSTOMER_AUTH = 'customer_auth__modal',
    IN_CALL = 'in_call__modal',
    NOTE = 'note_modal__modal',
    TICKET_SUMMARY = 'ticket_summary__modal'
}